import { featuresData } from '@/mocks/comics';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            阅读优势
          </h2>
          <p className="text-sm text-foreground-500">
            YY漫画为你打造的极致阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}